import {DomainObject} from 'shared/store';
import { action, observable, computed, makeObservable } from 'mobx';
import _ from 'lodash';
import {t} from 'shared/core';
import { v4 as uuidv4 } from 'uuid';

class QAQuestion extends DomainObject {
  uuid = uuidv4();
  questionType;
  order;
  text;
  required = false;
  args = {};

  constructor(other) {
    super();

    makeObservable(this, {
      questionType: observable,
      order: observable,
      text: observable,
      required: observable,
      args: observable,
      updateText: action,
      validate: action,
      questionName: computed,
      options: computed
    });

    this.merge(other);
  }

  updateText(value) {
    this.merge({text: value});
  }

  validate() {
    const errors = {};

    if (this.args.options && _.uniqBy(this.args.options, 'value').length !== this.args.options.length) {
      errors.options = t('errors.qa_question.Options must be unique');
    }
    _.forEach(this.args.options, option => {
      if (_.isEmpty(option.value.trim())) {
        errors.options = t("errors.qa_question.Options can't be blank");
      }
    });

    return errors;
  }

  get questionName() {
    return this.text;
  }

  get options() {
    return _.get(this.args, 'options');
  }
}

export default QAQuestion;
